import { useEffect, useState } from 'react';
import { fetchJsonCached } from '../lib/settingsCache';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Activity categories from Admin -> Tours & Charters.
 *
 * `favoritesOnly` returns just the categories that have been starred, which is what the
 * home page features - and only MAIN categories: a sub-category never belongs on the home
 * grid, so `top_level_only` is always sent with it. `topLevelOnly` can also be asked for on
 * its own. Everything is ordered by the category order number.
 */
export const useActivityCategories = ({ favoritesOnly = false, topLevelOnly = false } = {}) => {
  const [state, setState] = useState({ categories: [], loading: true });

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const params = new URLSearchParams();
      if (favoritesOnly) params.set('favorites_only', 'true');
      if (favoritesOnly || topLevelOnly) params.set('top_level_only', 'true');
      const query = params.toString();
      const url = `${API_URL}/api/public/tours-charters/categories${query ? `?${query}` : ''}`;
      try {
        const data = await fetchJsonCached(url);
        if (cancelled) return;
        setState({ categories: Array.isArray(data) ? data : [], loading: false });
      } catch (error) {
        if (!cancelled) setState({ categories: [], loading: false });
      }
    };

    load();
    return () => { cancelled = true; };
  }, [favoritesOnly, topLevelOnly]);

  return state;
};

export default useActivityCategories;
